import { Select } from '@iqueue/ui-kit'
import { useCallback, useRef } from 'react'
import SensorPresenter from '../../api/sensorPresenter'
import { t } from '../../hooks/useTranslate'

export default function PickSensor({
  current,
  value,
  onChange,
  ...props
}) {

  const cache = useRef()

  const render = useCallback((id) => {
    const item = cache.current.indexed[id]

    return {
      id: id,
      title: item?.devEUI,
      subtitle: item?.node?.name,
    }
  }, [t, current])

  const fetchData = useCallback(() => {
    return SensorPresenter.readIndexed(cache)
  }, [])

  const handleSelectChange = useCallback((id) => {
    onChange(id)
  }, [])

  return <Select
    allowSearch
    name={ name }
    entries={ fetchData }
    onChange={ handleSelectChange }
    render={ render }
    value={ value }
    { ...props }
  />
}
